import React, { Component } from 'react';
import { Modal, Button, Table, Tabs } from 'antd';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';

const TabPane = Tabs.TabPane;

const tabs = [{
    tab:'报价评估单',
    key:'PriceEvaluation',
    type: 'EVALUATE_SERVE_CUSTOMER',
},{
    tab:'访视评估-PM预测项目参数',
    key:'ForecastParams',
    type: 'EVALUATE_RECORD_CALCULATE',
},{
    tab:'访视评估-PM预测访视方案',
    key:'VisitingPlan',
    type: 'PLAN_VISIT_SUMMARY',
},{
    tab:'一口价（建议评估）',
    key:'FTEAssess',
    type: 'FTE_QUOTATION_PLAN',
}]

class UpdateLog extends Component {
    state = {
        data: [],
        record: {},
        visible: false,
        loading: false,
        activeKey: 'PriceEvaluation',
        type: 'EVALUATE_SERVE_CUSTOMER',
        pagination:{
            current:1,
            pageSize:10
        },
    }

    show = (record = {}) => {
        this.setState({
            record,
            visible: true,
        }, () => {
            this.loadData();
        });
    }

    hide = () => {
        this.setState({
            data: [],
            record: {},
            visible: false,
        });
    }

    loadData = () => {
        const { record, type, pagination } = this.state;
        const { current, pageSize } = pagination;
        const { evaluateRecordId } = record;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.evaluate.queryModifyLogList,
            data: { 
                offset: current,
                limit: pageSize,
                evaluateRecordId, 
                type,
            },
            dataType: 'json',
            doneResult: res => {
                const { datas, totalCount } = res; 
                pagination.total = totalCount;
                this.setState({
                    data: datas,
                    pagination,
                    loading: false,
                })
            }
        };
        $.sendRequest(options);
    }

    getColumns = () => [{
        title: '更新时间',
        dataIndex: 'createTime',
        key: 'createTime',
        width: 120,
    }, {
        title: '更新人',
        dataIndex: 'modifyUser',
        key: 'modifyUser',
        width: 120,
        render: (text, record) => {
            const { modifyUserName, modifyUserCode } = record;
            return `${modifyUserName}[${modifyUserCode}]`
        }
    }, {
        title: '更新字段',
        dataIndex: 'modifyFieldName',
        key: 'modifyFieldName',
        width: 120,
    }, {
        title: '更新前',
        dataIndex: 'beforeValue',
        key: 'beforeValue',
        width: 120,
    }, {
        title: '更新后',
        dataIndex: 'afterValue',
        key: 'afterValue',
        width: 120,
    }]

    handleTabClick = (key) => {
        const list = tabs.filter(el => el.key === key);
        const { pagination } = this.state;
        pagination.current = 1;
        this.setState({
            activeKey: key,
            type: list[0].type,
            pagination,
        },() => {
            this.loadData();
        })
    }

    handleTableChange = (pagination) => {
        this.setState({
            pagination,
        },() => {
            this.loadData();
        })
    }

    render() {
        const { visible, loading, data, activeKey, pagination } = this.state;
        return (
            <Modal
                title="更新日志"
                visible={visible}
                onCancel={this.hide}
                className="preview-modal"
                maskClosable={false}
                width="1000px"
                bodyStyle={{ maxHeight: 600 }}
                footer={<Button onClick={this.hide}>关闭</Button>}
            >
                <div className="cont-cont contract-record" style={{margin: 20}}>
                    <Tabs type="card" activeKey={activeKey} onChange={this.handleTabClick}>
                        {tabs.map(pane => <TabPane tab={pane.tab} key={pane.key}></TabPane>)}
                    </Tabs>
                    <div>
                        <Table
                            dataSource={data}
                            loading={loading}
                            columns={this.getColumns()}
                            pagination={pagination}
                            scroll={{ y: 400 }}
                            onChange={this.handleTableChange}
                        />
                        <div style={{ position: 'relative', top: -1, borderTop: '1px solid #e4e4e4' }} />
                    </div>
                </div>
            </Modal>
        );
    }
}

export default UpdateLog;


// WEBPACK FOOTER //
// ./src/components/clinicalEvaluation/clinicalEvaluationRecord/UpdateLog.js